import { useContext } from 'react';
import HashReferenceContext from 'src/contexts/HashReferenceContext';

const useHashReference = () => useContext(HashReferenceContext);

export default useHashReference;
